import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64ec0f70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading-wrap" }


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    animationVariant: { default: 'loading-spinner--blue' }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["loading-spinner", props.animationVariant])
    }, null, 2)
  ]))
}
}

})